var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items)?_c('ol',{staticClass:"ssp-breadcrumb"},_vm._l((_vm.items),function(it){return _c('li',[(it.path)?_c('a',{attrs:{"href":it.path}},[_vm._v(_vm._s(it.title))]):_c('span',[_vm._v(_vm._s(it.title))])])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12526784","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/Breadcrumb.vue
// module id = null
// module chunks = 